import { all } from "redux-saga/effects";

import applicationSagas from "../legacy/sagas/ApplicationSagas";
import dynamicFormSagas from "../legacy/sagas/DynamicFormSagas";
import errorSagas from "../legacy/sagas/ErrorSagas";
import evaluationsSaga from "../legacy/sagas/EvaluationsSaga";
import userSagas from "../legacy/sagas/UserSagas";
import initializeUserSaga from "./sagas/initializeUser";
import agentsSlice from "./slices/agents";
import apiPermissionsSaga from "./slices/apisV2/sagas/getApiPermission";
import apisV2Slice from "./slices/apisV2/slice";
import datasourcesSlice from "./slices/datasources";
import featureFlags from "./slices/featureFlags";
import organizationsSlice from "./slices/organizations";
import userSlice from "./slices/user";
import { initializeSaga, spawnSaga } from "./utils/effects";

const ROOT_SAGAS = [initializeUserSaga];

const LEGACY_SAGAS = [
  agentsSlice.rootSaga,
  organizationsSlice.rootSaga,
  apisV2Slice.rootSaga,
  datasourcesSlice.rootSaga,
  featureFlags.rootSaga,
  userSlice.rootSaga,
  errorSagas,
  applicationSagas,
  userSagas,
  evaluationsSaga,
  dynamicFormSagas,
  apiPermissionsSaga,
];

export default function* rootSaga() {
  yield all([
    ...LEGACY_SAGAS.map(spawnSaga),
    ...ROOT_SAGAS.map(initializeSaga),
  ]);
}
